import { PageListOfMetadataEntity, ModelingPageSearch, AppFormAction as AppFormActionProps } from 'api'
import http from 'services/http'
import moment from 'moment'
import { number } from 'prop-types'
export interface IApi<Input = {}, Output = {}> {
	api?: (data: Input) => Promise<Output | undefined>
	onApiAfter?: (data: Output | boolean) => void
	onApiBefore?: (data: Input) => Input | boolean | Promise<Input | boolean>
	data?: Input | boolean | ApiDataFunc<Input>
	extraApiData?: Partial<Input>
	apiPath: string
}
export async function doApi<Input, Output>(props: IApi<Input, Output>): Promise<Output | undefined> {
	let { api, onApiAfter, onApiBefore, data, extraApiData, apiPath } = props
	let finalData: Input
	let output: Output
	if (data === null || data === false) {
		throw new Error('api data   return false ')
	}
	if (typeof data === 'function') {
		let dataFuncResult = (data as ApiDataFunc<Input>)()
		if (typeof dataFuncResult !== 'boolean') finalData = dataFuncResult
		if (!dataFuncResult) throw new Error('api data function has return false ')
	} else if (typeof data !== 'boolean') {
		finalData = data
	}
	if (extraApiData) finalData = Object.assign({ apiPath }, finalData, extraApiData)
	for (let k in finalData) {
		if (finalData[k] instanceof moment) {
			finalData[k] = (finalData[k] as any).utcOffset(480).format('YYYY-MM-DDTHH:mm:ss')
		} else if (Array.isArray(finalData[k]) && finalData[k][0] instanceof moment) {
			finalData[k] = (finalData[k] as any)
				.map((item: any) => item.utcOffset(480).format('YYYY-MM-DDTHH:mm:ss'))
				.join('and')
		}
	}
	if (onApiBefore) {
		let apiResult = await onApiBefore(finalData)
		if (typeof apiResult !== 'object') throw new Error('on api before has return false')
		finalData = apiResult
	}
	finalData[apiPath] = apiPath
	try {
		output = await api(finalData)
		onApiAfter && onApiAfter(output)
	} catch (ex) {
		onApiAfter && onApiAfter(false)
		throw ex
	}
	return output
}
export interface PageListOfEntity {
	list?: any[]
	total?: number
}
export default {
	getPageList(modelingPageSearch: ModelingPageSearch): Promise<PageListOfEntity> {
		return http.get(modelingPageSearch.apiPath, { params: { ...modelingPageSearch } }).then(res => res.data)
	},
	postPageList(modelingPageSearch: ModelingPageSearch): Promise<PageListOfEntity> {
		return http.post(modelingPageSearch.apiPath, modelingPageSearch).then(res => res.data)
	},
	getFormData(iId: any): Promise<any> {
		return http.get(iId.apiPath, { params: { ...iId } }).then(res => res.data)
	},
}

export interface AppFormAction extends AppFormActionProps {
	onClick: (data: any) => void
}



// WEBPACK FOOTER //
// ./src/api/modelingApi.ts